<template>
    <div  :class="{'bodyfixed':ismodalshow,'bodyauto':!ismodalshow}">
        <div class="margin_top_100">
            <banner :list="bannerdata"></banner>
        </div>
        <div class="contain" v-if="rankdata.length > 0">
            <div class="inner">
                <div class="title">{{$t('index.rankTitle')}}</div>
                <div class="display_flex flex-wrap_wrap">
                    <div class="rankleft" v-for="(item,index) in rankdata" v-if="index == 0" @click="todetail('rank',item)">
                        <div class="cover" :style="{backgroundImage: 'url(' +  rankdata[0].listImage+ ')'}">
                            <div class="label_bought" :class="{'free':item.isFree,'bought':item.buyStatus}" v-if="item.buyStatus || item.isFree == '0'">{{item.buyStatus?langdesc.bought:(item.isFree=='0'?langdesc.free:'')}}</div>
                        </div>
                        <div class="name">
                            {{item.title}}
                        </div>
                        <div class="date display_flex justify-content_flex-justify">
                            <div>{{formatTimefun(item.publishTime)}}</div>
                            <span class="arr_class"></span>
                            <!-- <img src="../../assets/images/rang.png" width="16" height="16"> -->
                        </div>
                        <div class="rankguide">{{item.previewShoppingGuide}}</div>
                    </div>
                    <div class="display_flex  flex-wrap_wrap rankright">
                        <div class="rankitem" v-for="(item,index) in rankdata" v-if="index > 0 && index <5" @click="todetail('rank',item)">
                            <div class="coveritem" :style="{backgroundImage:'url('+ item.listImage +')'}">
                                <div class="label_bought" :class="{'free':item.isFree,'bought':item.buyStatus}" v-if="item.buyStatus || item.isFree == '0'">{{item.buyStatus?langdesc.bought:(item.isFree=='0'?langdesc.free:'')}}</div>
                            </div>
                            <div class="sec_name">{{item.title}}</div>
                            <div class="date display_flex justify-content_flex-justify">
                                <div>{{formatTimefun(item.publishTime)}}</div>
                                <span class="arr_class"></span>
                                <!-- <img src="../../assets/images/rang.png" width="16" height="16"> -->
                            </div>
                        </div>
                    </div>
                </div>
                <div class="more border" style="margin:20px auto 0;" @click="gorouter('/reportlist?type=rank')">
                    {{$t('index.morelist')}}
                </div>
            </div>
        </div>
        <div class="contain" v-if="reportdata.length > 0">
            <div class="inner">
                <div class="title">{{$t('index.new_report')}}</div>
                <div class="report_first" v-for="(item,index) in reportdata" v-if="index == 0" :style="{backgroundImage: 'url(' +  item.listImageLargePc+ ')'}" @click="todetail('report',item)">
                    <div class="label_bought" :class="{'free':item.isFree,'bought':item.buyStatus}" v-if="item.buyStatus || item.isFree == '0'">{{item.buyStatus?langdesc.bought:(item.isFree=='0'?langdesc.free:'')}}</div>
                    
                </div>
                <div class="display_flex justify-content_flex-justify padding-24-32">
                    <div class="reportitem" :style="{backgroundImage: 'url(' +  item.listImageMinPc+ ')'}" v-for="(item,index) in reportdata" v-if="index > 0 && index <3"  @click="todetail('report',item)">
                        <div class="label_bought" :class="{'free':item.isFree,'bought':item.buyStatus}" v-if="item.buyStatus || item.isFree == '0'">{{item.buyStatus?langdesc.bought:(item.isFree=='0'?langdesc.free:'')}}</div>
                    </div>
                    <!-- <div class="reportitem" :style="{backgroundImage: 'url(' +  reportdata[2].listImage+ ')'}"></div> -->
                </div>
                <div class="more " style="margin:0 auto;" @click="gorouter('/reportlist?type=report')">
                    {{$t('index.morereport')}}
                </div>
            </div>
        </div>
        <div class="contain" v-if="productArr.length > 0">
            <div class="inner">
                <div class="title display_flex justify-content_flex-justify align-items_flex-end">
                    <div>{{$t('index.productTitle')}}</div>
                    <div class="product-tap">
                        <span v-for="item in productArr" :class="{'active':currentproducttap == item.type}" @click="tabchoose(item)">{{item.title}}</span>
                       
                    </div>
                </div>
                <div class="index-swpier">
                    <swiper ref="mySwiper2" :options="swiperOptions2">
                        <swiper-slide v-for="(item,index) in productdata" :key="index">
                            <div   :class="['product_item',{'eng':currentlang == 'eng'}]" @click="toproductdetail(item)">
                                <div class="labelImg">
                                    <img :src="labelarr['green']" alt="" v-if="Number(item.fishClass) == 10">
                                    <img :src="labelarr['effect']" alt="" v-if="item.efficacy && item.efficacy.length > 0">
                                </div>
                                <div class="productImg" :style="{backgroundImage: 'url(' + item.img + ')'}">
                                </div>
                                <div class="padding_bottom_16">
                                    <div class="limit2">{{item.prdName}}</div>
                                </div>
                                <div class="productInfo display_flex justify-content_flex-justify" v-if="currentlang !== 'eng'">
                                    <span>{{$t('product.price')}}：<span class="main">{{item.price}}{{item.currency}}</span></span>
                                    <span>{{$t('product.address')}}：<span class="main">{{item.originplace}}</span></span>
                                </div>
                                <div v-if="currentlang == 'eng'">
                                    <div class="productInfo display_flex justify-content_flex-justify">
                                        <span class="flex_1">{{$t('product.price')}}：</span>
                                        <span class="flex_1">{{$t('product.address')}}：</span>
                                    </div>
                                    <div class="productInfo display_flex justify-content_flex-justify" style="padding-top: 8px;">
                                        <span class="flex_1 main">{{item.price}}{{item.currency}}</span>
                                        <span class="flex_1 main">{{item.originplace}}</span>
                                    </div>
                                </div>
                            </div>
                            <!--  <div class="trycontain productitem" style="height:360px;width
                                :282px;background-color:#fff;display:inline-block;margin-bottom:24px;" v-for="(item,index1) in 8" :key="index1">
                                <div class="position-relative" style="min-height:160px;">
                                    <div class="" style="width:160px;height:160px;background:#eee;margin:24px auto 10px"></div>
                                </div>
                                <div>
                                    <div class="padding-32 productname line2"><span class="trybal margin-right-10">试用</span>KIEHL'S科颜氏 亚马逊白泥净致面膜 (2018)逊白泥净致面膜</div>
                                    <div class=" productdetail display_flex justify-content_flex-justify">
                                        <img src="../../assets/images/greenfish.png" height="65" width="66">
                                        <div class="productitemdetail">
                                            <div class="productitemdetails ">
                                                <span class="fix-width-60">规格</span>
                                                <span class="color">500 ml</span>
                                            </div>
                                            <div class="productitemdetails ">
                                                <span class="fix-width-60">参考价格</span>
                                                <span class="color">126.5 元</span>
                                            </div>
                                            <div class="productitemdetails ">
                                                <span class="fix-width-60">品牌所在地</span>
                                                <span class="color">{{index1==1?'中国香港':'中国'}}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div> -->
                        </swiper-slide>
                        <div class="swiper-pagination2" slot="pagination"></div>
                    </swiper>
                    <div class="more" style="margin:32px auto 0;border: 1px solid #E9E9EB;" @click="gorouter('/product')">
                        {{$t('index.moreporduct')}}
                    </div>
                </div>
                <div>
                </div>
            </div>

            <!-- <div class="inner padding_top_64">
                <div class="try_contain">小鱼放心试 BANNER</div>
            </div> -->
            
        </div>
        <!-- 放心试 -->
        <div class="contain" v-if="false">
            <div class="inner">
                <div class="title display_flex  align-items_flex-end">
                    <div>{{$t('index.pc_try')}}</div>
                </div>
                <div class="index-swpier">
                    <swiper ref="mySwiper1" :options="swiperOptions">
                        <swiper-slide v-for="(item,index) in Trycurdata" :key="index" >
                            <div class="Try_Cover" @click="toasttry(item)">
                                <div class="trycontain display_flex justify-content_flex-justify flex-direction_column" style="height:330px;background-color:#fff;">
                                    <div class="position-relative" style="min-height:160px;">
                                        <div style="width:160px;height:160px;background:#fff;margin:24px auto 0" >
                                            <div class="tryboxImg" :style="{backgroundImage: 'url(' +  item.img+ ')'}" >
                                                <div class="productIcon" v-if="item.tryType == '1' || item.tryType == '2'"></div>
                                                <div class="productIconend" v-if="item.tryType == '3'">抢光了</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div class="padding-18 productname"><span :class="['trybal','margin-right-10',{'bgcolor1':item.tryType == '3'}]">{{item.tryType == '3'?'往期':'试用'}}</span><span>{{item.name}}</span></div>
                                        <div class="trydetail">
                                            <div style="padding-bottom:12px;">
                                                <span v-if="item.tryType == '1' || item.tryType == '3' ">{{$t('index.lefttime')}}</span>
                                                <span v-if="item.tryType == '2'">{{$t('index.start')}}</span>
                                                <span class="lefttime" v-if="item.tryType == '1'">{{lefttimefun(item.lefttime)}}</span>
                                                <span class="lefttime" v-if="item.tryType == '2'">{{lefttimefun(item.startleft)}}</span>
                                                <span class="lefttime color1" v-if="item.tryType == '3'">{{$t('index.try_end')}}</span>
                                            </div>
                                            <div>
                                                <span>{{$t('index.applynum')}}</span>
                                                <span :class="['lefttime',{'color1':item.tryType == '3'}]" v-if="item.tryType == '1' || item.tryType == '3'">{{item.applynum}}</span>
                                                <span class="lefttime" v-if="item.tryType == '2'">{{$t('index.wait')}}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="more trymore" v-if="item.tryType == '1' || item.tryType == '2'">
                                    {{item.tryType == '1'?'免费试用':'关注试用'}}
                                </div>
                                <div class="dueTry display_flex justify-content_flex-justify" v-if="item.tryType == '3'">
                                    <span><span class="color2">{{item.awardNum}}</span> 人中选</span>
                                    <div class="textalign_right">
                                        <div class="awardImg" v-for="(val,index1) in  item.awardUserList.userlist" :style="{backgroundImage: 'url(' +  val.image+ ')',zIndex:index1-1}"></div>
                                        <div class="awardImg"  style="backgroundImage: url('http://p1.fishqc.net/Fgkea_kCheHrJTpsdqpChV5Aoq99')"></div>
                                    </div>
                                </div>
                            </div>
                        </swiper-slide>
                        <div class="swiper-pagination1" slot="pagination" style="padding-top:35px;"></div>
                    </swiper>
                </div>
                <div class="more" style="margin:32px auto 0;border: 1px solid #E9E9EB;" @click="toastmoretry()">
                    {{$t('index.moretry')}}
                </div>
            </div>
        </div>
        <div class="contain">
            <div class="inner padding_top_64">
                <div class="title">
                    <div>{{$t('common.title')}}</div>
                </div>
                <div class="textalign_center">
                    <img :src="fishqcImg1" alt="">
                </div>
                <!-- <div class="display_flex justify-content_flex-justify">
                    <div class="technologic">
                        <div class="techpic"></div>
                        <div class="name">鲭鳉鱼胚胎-慢性毒检测</div>
                        <div class="intro ">应用2008年诺贝尔奖荧光标记技术，24小时快速筛查类雌性激素慢性毒物质应用2008年诺贝尔奖荧光标记技术，24小时快速筛查类雌性激素慢性毒物质</div>
                        <div class="textalign_right lineheight-16">
                            <img src="../../assets/images/rang.png" width="16" height="16">
                        </div>
                    </div>
                    <div class="technologic">
                        <div class="techpic"></div>
                        <div class="name">水中银斑马鱼胚胎-急性毒检测</div>
                        <div class="intro ">应用2008年诺贝尔奖荧光标记技术，24小时快速筛查类雌性激素慢性毒物质···</div>
                        <div class="textalign_right lineheight-16">
                            <img src="../../assets/images/rang.png" width="16" height="16">
                        </div>
                    </div>
                    <div class="technologic">
                        <div class="techpic"></div>
                        <div class="name">成分筛查</div>
                        <div class="intro ">应用2008年诺贝尔奖荧光标记技术，24小时快速筛查类雌性激素慢性毒物质···</div>
                        <div class="textalign_right lineheight-16">
                            <img src="../../assets/images/rang.png" width="16" height="16">
                        </div>
                    </div>
                </div> -->
            </div>
        </div>
        <!-- <div class="contain">
            <div class="inner">
                <div class="title display_flex  align-items_flex-end">
                    <div>用户测评</div>
                    <div class="test-intro">权威检测,严选优品,百万优品放心试</div>
                </div>
                <el-carousel :interval="4000" type="card" height="280px" :autoplay="false">
                    <el-carousel-item v-for="item in 5" :key="item">
                        <div class="cardcover">
                        </div>
                    </el-carousel-item>
                </el-carousel>
                <div class="more" style="margin:32px auto 0;border: 1px solid #E9E9EB;">
                    查看更多报告
                </div>
            </div>
        </div> -->
        <!-- <div class="contain">
            <div class="inner">
                <div class="title display_flex  align-items_flex-end">
                    <div>小鱼放心试</div>
                </div>
                <div class="index-swpier">
                    <swiper ref="mySwiper1" :options="swiperOptions">
                        <swiper-slide v-for="(item,index) in 9" :key="index">
                            <div class="trycontain display_flex justify-content_flex-justify flex-direction_column" style="height:330px;background-color:#fff;">
                                <div class="position-relative" style="min-height:160px;">
                                    <div class="" style="width:160px;height:160px;background:#eee;margin:24px auto 0"></div>
                                </div>
                                <div>
                                    <div class="padding-18 productname"><span>KIEHL'S科颜氏 亚马逊白泥净致白泥净致面膜白泥净致面膜面膜 (2018)</span><span class="trybal margin-left-10">试用</span></div>
                                    <div class="trydetail">
                                        <div style="padding-bottom:12px;">
                                            <span>剩余时间</span>
                                            <span class="lefttime">2天20时23分</span>
                                        </div>
                                        <div>
                                            <span>报名人数</span>
                                            <span class="lefttime">2939</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="more" style="width:280px;border: 1px solid #60DEB4;color:#60DEB4;margin-top:16px;">
                                免费试用
                            </div>
                        </swiper-slide>
                        <div class="swiper-pagination1" slot="pagination" style="padding-top:35px;"></div>
                    </swiper>
                </div>
                <div class="more" style="margin:32px auto 0;border: 1px solid #E9E9EB;">
                    查看更多试用
                </div>
            </div>
        </div> -->
        <div class="contain" v-if="articledata.length > 0">
            <div class="inner">
                <div class="title">{{$t('index.article')}}</div>
                <div class="display_flex justify-content_flex-justify">
                    <div class="rankleft" v-for="(item,index) in articledata" v-if="index == 0" @click="toarticaldetail(item)">
                        <div class="height-330" :style="{backgroundImage: 'url(' + item.listImage + ')'}">
                        </div>
                    </div>
                    <div class="rankleft display_flex justify-content_flex-justify flex-direction_column" style="height:330px;">
                        <div class="display_flex justify-content_flex-justify " v-for="(item,index) in articledata" v-if="(index > 0) && (index < 3)"  @click="toarticaldetail(item)">
                            <div class="acticleitem" :style="{backgroundImage: 'url(' + item.listImage + ')'}">
                            </div>
                            <div class="acticle-detail">
                                <div class="sec_name">{{item.title}}</div>
                                <div class="date">
                                    <!-- <div>{{formatTimefun(item.publishTime)}}</div> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="more" style="margin:32px auto 0;" @click="gorouter('/article')">
                    {{$t('index.morearticle')}}
                </div>
            </div>
        </div>
        <!-- <div class="contain">
            <div class="inner">
                <div class="title display_flex  align-items_flex-end">
                    <div>测评优势</div>
                    <div class="test-intro">更值得信赖的检测体系</div>
                </div>
                <div class="display_flex justify-content_flex-center align-items_center">
                    <div class="display_flex align-items_center">
                        <span class="chemical-test">化学测试</span>
                        <img src="" style="background-color:#eee" width="236" height="248">
                    </div>
                    <div class="vs">VS</div>
                    <div class="display_flex align-items_center">
                        <img src="" style="background-color:#eee" width="236" height="248">
                        <ul class="vs-right-ul">
                            <li >
                                <span class="vs-right-li">鲭鳉鱼胚胎慢性毒物测试</span>
                            </li>
                            <li >
                                <span class="vs-right-li">斑马鱼胚胎急性毒物测试</span>
                            </li>
                            <li >
                                <span class="vs-right-li">禁用成分筛查</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div> -->
        <div class="contain">
            <div class="inner">
                <div class="display_flex justify-content_flex-justify">
                    <div class="width-588">
                        <div class="title  display_flex  align-items_flex-end">
                            <div>{{$t('index.level')}}</div>
                            <div class="test-intro" v-if="currentlang !=='eng'">{{$t('common.leveldesc5')}}</div>
                        </div>
                        <div class="padding-25">
                            <img :src="fishlevelimg" alt="" width="529" height="342">
                        </div>
                    </div>
                    <div class="width-588">
                        <div class="title  display_flex  align-items_flex-end">
                            <div>{{$t('index.lab')}}</div>
                            <div class="test-intro" v-if="currentlang !=='eng'">{{$t('common.leveldesc6')}}</div>
                        </div>
                        <div class="padding-16 cursor_pointer">
                            <!-- <div v-if="isshowvideo" @click="playvideo">
                                <img src="../../assets/images/video-cover.png" alt="" width="556" height="358">
                                <img src="../../assets/images/video-btn.png" alt="" width="64" height="64" class="center">
                            </div> -->
                            <div>
                                <video src="https://p1.fishqc.net/dzq-lab.mp4" poster="https://p1.fishqc.net/FkazKTnti7evwO-V5uyRk6P3CHii" width="556" height="358" controls="controls"></video>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <modal ref="modaltoast" @modalthings="getmaterial"></modal>
    </div>
</template>
<style lang="scss" scoped>
@import "@/assets/css/mixin.scss";

.padding_top_64 {
    padding-top: 64px;
    box-sizing: border-box;
}

.try_contain {
    width: 100%;
    height: 300px;
    line-height: 300px;
    background: #60DEB4;
    text-align: center;
    font-size: 56px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #B5FFE6;
}

.margin_top_100 {
    margin-top: 100px;
    // padding: 32px 0 64px;
}

.title {
    font-size: 32px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #262633;
    line-height: 32px;
    padding-bottom: 32px;
}



.contain {
    text-align: left;
    background-color: #fff;
    padding: 64px 0;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #2F3736;

    .date {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #A8A8AD;
        line-height: 24px;
    }

    &:nth-of-type(2n-1) {
        background-color: #F8FBFD;
      
    }

    .more {
        width: 246px;
        height: 48px;
        text-align: center;
        line-height: 48px;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #51515C;
        letter-spacing: 4px;
        cursor: pointer;
        background: url('../../assets/images/arr.png') no-repeat 210px 20px;
        background-color: #FFFFFF;
        &.border{
            border: 1px solid #E9E9EB;
        }

        &:hover{
            color: #fff;
            background: url('https://p1.fishqc.net/FlRbIiMKiKzC7ci97sZYFJ284KUS') no-repeat 210px 20px;
            background-color: #60DEB4;
        }
        
        
    }
}

.rankleft {
    width: 588px;
    cursor: pointer;

    .cover {
        height: 434px;
        background-color: #fff;
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center center;
        position: relative;
        &:hover{
            box-shadow: 0 0px 20px 0px rgba(0,0,0,0.1);
        }
        .label_bought{
            width:48px;
            height: 24px;
            background: linear-gradient(270deg, #FB8B4A 0%, #F5D874 100%);
            border-radius: 0px 0px 32px 0px;
            display: inline-block;
            position: absolute;
            left:0;
            top:0;
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #FFFFFF;
            line-height: 24px;
            padding:0 14px 0 10px;
            box-sizing: border-box;
            &.free{
                    background: linear-gradient(270deg, #0DC6B8 0%, #28D877 100%);
            }
            &.bought{
                background: linear-gradient(270deg, #F5D874 0%, #FB8B4A 100%);
            }
        }
    }



    .name {
        padding-top: 14px;
        font-size: 20px;
        line-height: 32px;
        padding-bottom: 9px;
        &:hover{
            color: #60DEB4;
        }
    }

    .height-330 {
        height: 330px;
        background-color: #fff;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center center;
        &:hover{
            box-shadow: 0 0px 20px 0px rgba(0,0,0,0.2);
        }
    }

    .arr_class{
        width: 16px;
        height: 16px;
        background:url('https://p1.fishqc.net/FnYLs27U2KnItqo4mmN70Npm_ryS') center center no-repeat;
        background-position: center center;
        background-size: contain;
        display: inline-block;
    }
    &:hover{
        .arr_class{
            width: 16px;
            height: 16px;
            background:url('https://p1.fishqc.net/FvGC_jKqH1Pp2AI2LjaR2n0JdxDj') center center no-repeat;
            background-position: center center;
            background-size: contain;
            display: inline-block;
        }
    }


}

.rankright {
    width: 612px;

    .rankitem {
        margin-right: 0;
        margin-left: 24px;

        &:nth-of-type(3) {
            margin-bottom: 0;
        }

        &:nth-of-type(4) {
            margin-bottom: 0;
        }

        .coveritem {
            height: 208px;
            // background-color: #eee;
            background-position: center center;
            background-repeat: no-repeat;
            background-size: cover;
            position: relative;
            &:hover{
                box-shadow: 0 0px 20px 0px rgba(0,0,0,0.1);
            }
            .label_bought{
                width:48px;
                height: 24px;
                background: linear-gradient(270deg, #FB8B4A 0%, #F5D874 100%);
                border-radius: 0px 0px 32px 0px;
                display: inline-block;
                position: absolute;
                left:0;
                top:0;
                font-size: 12px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #FFFFFF;
                line-height: 24px;
                padding:0 14px 0 10px;
                box-sizing: border-box;
                &.free{
                        background: linear-gradient(270deg, #0DC6B8 0%, #28D877 100%);
                }
                &.bought{
                    background: linear-gradient(270deg, #F5D874 0%, #FB8B4A 100%);
                }
            }
        }

        .arr_class{
            width: 16px;
            height: 16px;
            background:url('https://p1.fishqc.net/FnYLs27U2KnItqo4mmN70Npm_ryS') center center no-repeat;
            background-position: center center;
            background-size: contain;
            display: inline-block;
        }
        &:hover{
            .arr_class{
                width: 16px;
                height: 16px;
                background:url('https://p1.fishqc.net/FvGC_jKqH1Pp2AI2LjaR2n0JdxDj') center center no-repeat;
                background-position: center center;
                background-size: contain;
                display: inline-block;
            }
        }

    }
}



.report_first {
    height: 400px;
    background-color: #fff;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    cursor: pointer;
    position:relative;
    &:hover{
        box-shadow: 0 0px 20px 0px rgba(0,0,0,0.1);
    }
    .label_bought{
        width:48px;
        height: 24px;
        background: linear-gradient(270deg, #FB8B4A 0%, #F5D874 100%);
        border-radius: 0px 0px 32px 0px;
        display: inline-block;
        position: absolute;
        left:0;
        top:0;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 24px;
        padding:0 14px 0 10px;
        box-sizing: border-box;
        &.free{
                background: linear-gradient(270deg, #0DC6B8 0%, #28D877 100%);
        }
        &.bought{
            background: linear-gradient(270deg, #F5D874 0%, #FB8B4A 100%);
        }
    }
}

.padding-24-32 {
    padding: 24px 0 32px;
}

.reportitem {
    width: 588px;
    height: 196px;
    background-color: #fff;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    cursor: pointer;
    position: relative;
    &:hover{
            box-shadow: 0 0px 20px 0px rgba(0,0,0,0.1);
        }
    .label_bought{
        width:48px;
        height: 24px;
        background: linear-gradient(270deg, #FB8B4A 0%, #F5D874 100%);
        border-radius: 0px 0px 32px 0px;
        display: inline-block;
        position: absolute;
        left:0;
        top:0;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 24px;
        padding:0 14px 0 10px;
        box-sizing: border-box;
        &.free{
                background: linear-gradient(270deg, #0DC6B8 0%, #28D877 100%);
        }
        &.bought{
            background: linear-gradient(270deg, #F5D874 0%, #FB8B4A 100%);
        }
    }
}

.product-tap {
    span {
        display: inline-block;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #51515C;
        // padding: 0 12px;
        line-height: 16px;
        cursor: pointer;
        margin-left: 24px;
    }

    .active {
        color: #60DEB4;
    }
}



.test-intro {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #51515C;
    margin-left: 24px;
    line-height: 14px;
}

/* 焦点·参考swiper.min.css源文件修改 */

.el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 200px;
    margin: 0;
}

.el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
    // background-color: #fff;
}

.el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
    // background-color: #fff;
}

.el-carousel__item--card {
    // width:516px; 

}

.cardcover {
    width: 100%;
    height: 100%;
    // background: #fff;
    border: 1px solid #eee;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);

}

.technologic {
    width: 384px;
    border-bottom: 1px solid #E9E9EB;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    line-height: 24px;

    .techpic {
        height: 295px;
        background-color: #eee;
    }

    .name {
        font-size: 16px;
        padding: 16px 0 12px;
        color: #2F3736;

    }

    .lineheight-16 {
        line-height: 16px;
        padding-bottom: 12px;
        padding-top: 16px;
        box-sizing: border-box;
    }

    .intro {
        height: 48px;
        font-size: 14px;
        color: #A8A8AD;
        @include linelimt(2);

    }
}

.acticleitem {
    width: 282px;
    height: 154px;
    display: inline-block;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    &:hover{
        box-shadow: 0 0px 20px 0px rgba(0,0,0,0.1);
    }
    
}

.acticle-detail {
    display: inline-block;
    width: 284px;
    margin-left: 28px;

    .sec_name {

        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #262633;
        line-height: 28px;
        padding-bottom: 22px;
        padding-right: 40px;
        &:hover{
            color: #60DEB4;
        }
    }
}

.width-588 {
    width: 588px;
}

.padding-25 {
    padding: 25px;
    background: #fff;
}

.padding-16 {
    padding: 16px;
    background: #fff;
    position: relative;

    .center {
        @include center;
    }

}

.trybtn {
    width: 280px;
    height: 48px;
    line-height: 48px;
    background-color: #60DEB4;
    border: 1px solid #60DEB4;
    color: #fff;
    margin-top: 16px;
}

.yugao {
    background-color: #F8FBFD;
    color: #60DEB4;
    border: 1px solid #60DEB4;
}

.padding-18 {
    padding: 0px 18px;
}

.padding-32 {
    padding: 0px 32px;
}
.Try_Cover{
    display: inline-block;
    vertical-align: top;
    cursor: pointer;
    .dueTry{
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #262633;
        line-height: 14px;
        width: 280px;
        height: 48px;
        line-height:48px;
        margin-top: 16px;
        .color2{
            color:#6EDCC7;
        }

        .awardImg{
            width:32px;
            height: 32px;
            display: inline-block;
            background-position: center;
            background-size: cover;
            background-repeat: no-repeat;
            border-radius: 50%;
            border: 3px solid #fff;
            margin-left: -9px;

        }
    }
    .trymore{
        width:280px;
        border: 1px solid #60DEB4;
        color:#60DEB4;
        margin-top:16px;
        background:none;
    }
    &:hover{
        .trymore{
            width:280px;
            border: 1px solid #60DEB4;
            color:#fff;
            margin-top:16px;
            background-color: #60DEB4;
            background-image: url('http://p1.fishqc.net/FlRbIiMKiKzC7ci97sZYFJ284KUS');
            background-repeat:  no-repeat;
            background-position: 210px 20px;  
        }
    }
}
.trycontain {
    .productname {
        font-size: 16px;
        line-height:26px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #2F3736;
        line-height: 24px;
        // padding-bottom: 10px;
        height: 48px;
        margin-bottom: 6px;
        @include linelimt(2)
    }

    .productdetail {
        margin: 10px 32px 0;
        padding-top: 10px;
        box-sizing: border-box;
        border-top: 1px solid #F8F8F8;
    }

    .trydetail {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #9B9B9B;
        line-height: 14px;
        padding-top: 14px;
        padding-bottom: 20px;
        border-top: 1px solid #F8F8F8;
        margin: 0 18px;

        .lefttime {
            padding-left: 24px;
            color: #60DEB4;
            &.color1{
                color:#A8A8AD;
            }
        }
    }

    &.productitem {
        margin-right: 24px;

        &:nth-of-type(4n) {
            margin-right: 0px !important;
        }

    }

    .productitemdetail {
        font-size: 12px;

        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #9B9B9B;

        .productitemdetails {
            padding: 6px 0;
            border-bottom: 1px solid #F8F8F8;

            &:last-child {
                border-bottom: none;
            }

            .color {
                color: #333;
            }

            .fix-width-60 {
                width: 76px;
                display: inline-block;
            }
        }
    }






}

.position-relative {
    position: relative;

    .center {
        @include center;
    }
}

.vs {
    width: 42px;
    height: 42px;
    background: #D5D5D7;
    border-radius: 50%;
    font-size: 21px;
    font-family: Arial-BoldMT, Arial;
    font-weight: normal;
    color: #FFFFFF;
    line-height: 42px;
    text-align: center;
    margin: 0 30px;
}

.chemical-test {
    width: 94px;
    height: 26px;
    background: #F4F4F5;
    border-radius: 16px;
    font-size: 16px;
    font-family: PingFang-SC-Regular, PingFang-SC;
    font-weight: 400;
    color: #A8A8AD;
    line-height: 26px;
    display: inline-block;
    text-align: center;
    position: relative;
    margin-right: 39px;

    &:after {
        content: '';
        width: 13px;
        height: 13px;
        display: inline-block;
        border-radius: 50%;
        background-color: #A8A8AD;
        position: absolute;
        right: -19px;
        top: 5px;
    }
}

.vs-right-ul {
    margin-left: 10px;
}

.vs-right-li {
    height: 32px;
    line-height: 32px;
    background: #F0FFFC;
    border-radius: 16px;
    background-color: #F0FFFC;
    font-size: 16px;
    font-family: PingFang-SC-Regular, PingFang-SC;
    font-weight: 400;
    color: #60DEB4;
    padding: 0 20px 0 30px;
    margin-bottom: 14px;
    display: inline-block;
    position: relative;

    &:before {
        content: '';
        width: 13px;
        height: 13px;
        display: inline-block;
        border-radius: 50%;
        background-color: #60DEB4;
        position: absolute;
        left: 9px;
        top: 10px;
    }
}

.margin-right-10 {
    margin-right: 10px;
}

.margin-right-10 {
    margin-right: 10px;
}
.cursor_pointer{
    cursor: pointer;
}

.rankguide{
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    line-height: 30px;
    &:hover{
        color: #60DEB4;
    }
}

.tryboxImg{
    width:160px;
    height: 160px;
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    margin:0 auto;
    position: relative;
    .productIcon{
        width: 66px;
        height: 65px;
        background: url('http://p1.fishqc.net/FicOjAi0v3VH-qPDpIpy3pXjW04U') center center no-repeat;
        background-size: contain;
        position: absolute;
        right:0;
        bottom:0px;
    }
    .productIconend{
        width: 64px;
        height: 64px;
        line-height: 64px;
        background-color: rgba(0,0,0,.4);
        color:#fff;
        font-size: 16px;
        text-align: center;
        position: absolute;
        left:50%;
        top:50%;
        transform: translate(-50%,-50%);
        border-radius: 50%;

    }
}
</style>
<style type="text/css" lang="scss">
/* 轮播图 */
.swiper-container {
    width: 100%;
    height: 100%;
}

// .swiper-wrapper{
//  height: 430px;
// }
.swiper-slide {
    background-position: center;
    background-size: cover;

}

.index-swpier {
    .swiper-pagination-bullet {
        width: 8px;
        height: 8px;
        background: #E5E5E5;
        border-radius: 4px;

        &.swiper-pagination-bullet-active {
            width: 16px;
            height: 8px;
            background: #76E2D2;
            border-radius: 4px;
        }
    }

    .swiper-pagination-fraction,
    .swiper-pagination-custom,
    .swiper-container-horizontal>.swiper-pagination-bullets {
        text-align: center;
    }
}
</style>
<script>
import Vue from 'vue'
// @ is an alias to /src
import banner from '@/components/banner.vue'
import {getBannerApi,getranklistApi,getreportlistApi,getproductlistApi,getarticlelistApi,Trycurlistapi,tryNoticeListapi,getduelistapi} from '@/api/api.js'
import {myMixin} from '@/mixin/mixin.js'
import {formatTime,formatSeconds} from '@/utils/other.js'
import { getCookie } from '@/utils/cookieUtil'
import Modal from '@/components/Modal.vue'
// import VideoPlayer from 'vue-video-player'
// require('video.js/dist/video-js.css')
// require('vue-video-player/src/custom-theme.css')

// Vue.use(VideoPlayer)
export default {
    name: '',
    components: {
        banner,
        modal:Modal
    },
    mixins:[myMixin],
    data() {
        return {
            isshowvideo: true,
            swiperOptions: {
                pagination: {
                    el: '.swiper-pagination1'
                },
                uniqueNavElements: false,
                slidesPerView: 4,
                slidesPerGroup: 3,
                spaceBetween: 24,
                autoplay:true,
                // Some Swiper option/callback...
            },
            swiperOptions2: {
                pagination: {
                    el: '.swiper-pagination2'
                },
                uniqueNavElements: false,
                slidesPerView : 4,
                slidesPerColumn : 2,
                slidesPerGroup : 4,
                slidesPerColumnFill : 'row',
                autoplay:true,

                // Some Swiper option/callback...
            },
            bannerdata:[],
            rankdata:[],
            reportdata:[],
            currentpage:1,
            productArr: [{
                    title: this.$t('index.lasttest'),
                    type: 'all',
                    icon: 'http://p1.fishqc.net/FpdcTIdDaN3eG9qH17yxwYxVBXGu',
                    iconActive: 'http://p1.fishqc.net/Fsn9dxNpktTOmlI7uQmkV1pnR5YR'
                },
                {
                    title: this.$t('product.menu2'),
                    type: 'cosmetic',
                    icon: 'http://p1.fishqc.net/Fpyj3jPDC-6NzUla8wzcV96wa8CS',
                    iconActive: 'http://p1.fishqc.net/Fk0boQaSnqMX8pzRjWifPOLK4Bek'
                },
                {
                    title: this.$t('product.menu3'),
                    type: 'motherbaby',
                    icon: 'http://p1.fishqc.net/Ft7UswRid2Lt575FyD8T3uXRlpAV',
                    iconActive: 'http://p1.fishqc.net/Fk0boQaSnqMX8pzRjWifPOLK4Bek'
                },
                {
                    title: this.$t('product.menu4'),
                    type: 'healthcare',
                    icon: 'http://p1.fishqc.net/FgJolXc83WQUrbD5OrI7fFzNgTj0',
                    iconActive: 'http://p1.fishqc.net/Fk0boQaSnqMX8pzRjWifPOLK4Bek'
                },
                {
                    title: this.$t('product.menu5'),
                    type: 'food',
                    icon: 'http://p1.fishqc.net/FuWPV77HJkySvNd4QWSd79GMPnlU',
                    iconActive: 'http://p1.fishqc.net/Fk0boQaSnqMX8pzRjWifPOLK4Bek'
                },
                {
                    title: this.$t('product.menu6'),
                    type: 'others',
                    icon: 'http://p1.fishqc.net/FjpdHZZWappd6udS6Bd69sABa4oN',
                    iconActive: 'http://p1.fishqc.net/Fk0boQaSnqMX8pzRjWifPOLK4Bek'
                }

            ],
            currentproducttap: 'all',
            productdata:{
             
            },
            articledata:[],   //文章
            ismodalshow:false,
            Trycurdata:[],
            langdesc:{
                bought:this.$t('rankindex.bought'),
                free:this.$t('index.free')
            },
            currentlang:'',
            fishqcImg1:this.$t('index.fishqcImg1'),
            fishlevelimg:this.$t('index.fishlevelimg')
        }
    },
    computed: {
        swiper() {
            return this.$refs.mySwiper1.$swiper
        },
        formatTimefun(){
            return function(ctime){
                return formatTime(ctime,'Y/M/D')
            }
        },
        // 秒数转格式
        lefttimefun(){
            return function(lefttime){
                return formatSeconds(lefttime)
            }
        },
    },
    mounted() {
        this.currentlang  = window.localStorage.getItem("LOCALE") ||  'chs'
        this.getbanner()
        this.getranklist()
        this.getreportlist()
        this.getarticlelist()
        this.getproductlist(this.currentproducttap)
        this.Trycurlist()
    },
    methods: {
        playvideo() {
            this.isshowvideo = false
        },
        getbanner(){
            getBannerApi({
                lang:window.localStorage.getItem("LOCALE") ||  'chs',
                device:1
            }).then(res => {
                console.log(res)
                if (res.code == 200) {
                    this.bannerdata = res.data.list
                } else {
                    // this.toast(res.message)

                }
            })
        },
        getranklist(){
            getranklistApi({
                lang:window.localStorage.getItem("LOCALE") ||  'chs',
                device:1,
                page:this.currentpage,
                limit:6
            }).then(res => {
                console.log(res)
                if (res.code == 200) {
                    this.rankdata = res.data.list
                    // console.log('榜单数据',this.rankdata)
                }else if(res.code == 204){
                    this.rankdata = []
                }else {
                    // this.toast(res.message)

                }
            })
        },
        getreportlist(){
            getreportlistApi({
                lang:window.localStorage.getItem("LOCALE") ||  'chs',
                device:1,
                page:this.currentpage,
                limit:6
            }).then(res => {
                console.log(res)
                if (res.code == 200) {
                    this.reportdata = res.data.list
                }else if(res.code == 204){
                    this.reportdata = []
                } else {
                    // this.toast(res.message)

                }
            })
        },
        getproductlist(type) {
            getproductlistApi({
                lang:window.localStorage.getItem("LOCALE") ||  'chs',
                type:type,
                page: this.currentpage,
                limit: 24
            }).then(res => {
                if (res.code == 200) {
                    this.productdata = res.data.list
                    
                } else {
                    // this.toast(res.message)

                }
            })
        },

        tabchoose(item){
            this.currentproducttap = item.type
            this.$refs.mySwiper2.$swiper.slideTo(0, 0, false);
            this.getproductlist(item.type)
        },
        getarticlelist(){
            getarticlelistApi({
                lang:window.localStorage.getItem("LOCALE") ||  'chs',
                device:1,
                page:this.currentpage,
                limit:6
            }).then(res => {
                console.log(res)
                if (res.code == 200) {
                    this.articledata = res.data.list
                } else {
                    // this.toast(res.message)

                }
            })
        },
        todetail(type,item){
            // if(item.buyStatus){
            //     this.toast('请勿重复购买！')
            //     return
            // }
            switch(type){
                case  'report':
                    if(item.buyStatus){  //已购买状态，进入详情
                        this.gorouter('/report/detail/'+item.reportUnionId)
                    }else{   //弹出导购弹窗，有previewVideo，弹窗视频导购，否则图片导购
                        this.ismodalshow = true
                        this.$refs.modaltoast.show({
                            type:'guide',  //弹窗类型，guide:导购页
                            itemtype:'2',    //报告
                            itemdata:item
                        });
                    }
                break;
                case  'rank':
                    // if(item.buyStatus){  //已购买榜单，进入详情
                    //     this.gorouter('/rank/detail/'+item.rankingUnionId)
                    // }else{
                    //     this.ismodalshow = true
                    //     this.$refs.modaltoast.show({
                    //         type:'guide',
                    //         itemtype:'1',    //榜单
                    //         itemdata:item
                    //     });
                    // }
                    // 
                    if(getCookie('fqcU')){
                        if(item.buyStatus){  //已购买榜单，进入详情
                            if(item.rankingType == '3'){
                                if(item.urlPc){
                                    window.location.href = item.urlPc
                                }
                            }else{
                                this.gorouter('/rank/detail/'+item.rankingUnionId)
                            }
                        }else{
                            this.ismodalshow = true
                            this.$refs.modaltoast.show({
                                type:'guide',
                                itemtype:'1',    //榜单
                                itemdata:item
                            });
                        }
                    }else{ //未登录
                        if(item.rankingType == '3'){ //专题榜单
                            if(item.urlPc){
                                window.location.href = item.urlPc
                            }
                        }else{   // 非专题榜单

                            if(item.buyStatus){  //已购买榜单，进入详情
                                this.gorouter('/rank/detail/'+item.rankingUnionId)
                            }else{
                                this.ismodalshow = true
                                this.$refs.modaltoast.show({
                                    type:'guide',
                                    itemtype:'1',    //榜单
                                    itemdata:item
                                });
                            }
                        }
                    }

                    // 
                break;
            }
        },
        getmaterial(e){
            console.log('回调弹窗关闭状态',e)
            this.ismodalshow = e.showstatus
        },
        toproductdetail(item) {
            this.$router.push({
                path: '/product/'+item.productType+'/'+item.productId
            })
        },
        toarticaldetail(item){
            this.gorouter('/article/detail/'+item.cmsId)
        },
        // 获取当期试用
        getcurrenttry(){

        },
        Trycurlist(type) {
            Trycurlistapi({
                lang:window.localStorage.getItem("LOCALE") ||  'chs',
                page: this.currentpage,
                limit: 8
            }).then(res => {
                if (res.code == 200) {
                    console.log(res.data)
                    for(var i=0;i<res.data.curTryInfo.length;i++){
                        res.data.curTryInfo[i].tryType = '1'
                    }
                    this.Trycurdata = res.data.curTryInfo
                    this.tryNoticeList()
                }else if(res.code == 204){  //无数据
                    // for(var i=0;i<res.data.curTryInfo.length;i++){
                    //     res.data.curTryInfo[i].tryType = '1'
                    // }
                    // this.Trycurdata = res.data.tryList.curTryInfo
                    this.tryNoticeList()
                }   
                else {
                    this.toast(res.message)

                }
            })
        },
        tryNoticeList(type) {
            tryNoticeListapi({
                lang:window.localStorage.getItem("LOCALE") ||  'chs',
                page: this.currentpage,
                limit: 8
            }).then(res => {
                if (res.code == 200) {
                    console.log(res.data)
                    for(var i=0;i<res.data.curNoticeList.length;i++){
                        res.data.curNoticeList[i].tryType = '2'
                    }
                    this.Trycurdata = this.Trycurdata.concat(res.data.curNoticeList)
                    this.getdueList()
                }else if(res.code == 204){
                    // for(var i=0;i<res.data.curNoticeList.length;i++){
                    //     res.data.curNoticeList[i].tryType = '2'
                    // }
                    // this.Trycurdata = this.Trycurdata.concat(res.data.curNoticeList)
                    this.getdueList()
                }else {
                    this.toast(res.message)

                }
            })
        },
        getdueList(type) {
            getduelistapi({
                lang:window.localStorage.getItem("LOCALE") ||  'chs',
                page: this.currentpage,
                limit: 8
            }).then(res => {
                if (res.code == 200) {
                    for(var i=0;i<res.data.tryInfo.length;i++){
                        res.data.tryInfo[i].tryType = '3'
                    }
                    console.log(res.data)
                    this.Trycurdata = this.Trycurdata.concat(res.data.tryInfo)
                    
                } else {
                    this.toast(res.message)

                }
            })
        },
        toasttry(item){
            console.log(item)
            // 触发放心试弹窗
            this.$refs.modaltoast.show({
                type:'try',
                try_url:'https://try.fishqc.com/detail/'+item.id+'?id='+item.id
            });
        },
        toastmoretry(){
            // 触发放心试弹窗
            this.$refs.modaltoast.show({
                type:'try',
                try_url:'https://try.fishqc.com'
            });
        }
        
    }
}
</script>